import { useMemo } from "react";
import Ajv from "ajv";
import ajvErrors from "ajv-errors";
import ajvFormats from "ajv-formats";
import { useTranslation } from "react-i18next";

function extractInterpolationParams(err) {
  switch (err.keyword) {
    case "maxLength":
    case "maximum":
      return { max: err.params?.limit };
    case "minLength":
    case "minimum":
      return { min: err.params?.limit };
    case "pattern":
      return { pattern: err.params?.pattern };
    case "type":
      return { type: err.params?.type };
    default:
      return {};
  }
}

function formatLabel(label, lang) {
  const needsSpaceBeforeColon = ["fr", "fr-FR", "fr-CA"].includes(lang);
  return needsSpaceBeforeColon ? `${label}\u00A0:` : `${label}:`;
}

export function useItemValidation(schema) {
  const { t, i18n } = useTranslation();

  const getTranslation = (err) => {
    switch (err.keyword) {
      case "maxLength":
        return t("validation.max", { max: err.params?.limit });
      case "minLength":
        return t("validation.min", { min: err.params?.limit });
      case "required":
        return t("validation.required");
      default:
        return t("validation.unknown");
    }
  };

  const ajv = useMemo(() => {
    const instance = new Ajv({
      allErrors: true,
      strict: false,
      verbose: true,
    });
    ajvErrors(instance);
    ajvFormats(instance);
    return instance;
  }, []);

  const validate = useMemo(() => ajv.compile(schema), []);

  return (data) => {
    const isValid = validate(data);
    if (isValid) return {};

    const errors = {};

    for (const err of validate.errors || []) {
      let field = "unknown";

      if (err.instancePath?.length > 0) {
        console.log("err:", err);
        const segments = err.instancePath.split("/").filter(Boolean);
        field = segments.at(-1) || field;
      } else if (err.params?.missingProperty) {
        field = err.params.missingProperty;
      }

      const i18nKey = t("generic." + field, { defaultValue: field });
      //console.log(`Looking for translation for ${i18nKey}`);

      //const i18nMessage = err.message || "validation.unknown";
      const translated = getTranslation(err);

      errors[field] = (
        <span className="error-text">
          {formatLabel(i18nKey, i18n.language)} {translated}
        </span>
      );
    }

    return errors;
  };
}
